export const WorkSection = () => {
    return (
        <>
            <section className="works-section" id="work_sec1"   aria-labelledby="work-heading">
                    <div className="container">
                        <div className="row pt-4  text-center">
                            <h1  id="work-heading" className="mb-3 mt-4">How it <span style={{color:'#00675B'}}>Works</span></h1>
                            <p id="work1">Step into the world of government innovation by contributing code. Here’s how you can get started today</p>
                            <div className="container_1 mb-4">
                                
                                <div className="step">
                                    <h1>01</h1>
                                    <span className="number">01</span>
                                    <div className="circle"></div>
                                    <h2 style={{ color: '#00675B',fontSize: '20px',fontWeight: 700}}>Browse Challenges</h2>
                                    <p>Explore government-backed coding projects.</p>
                                </div>
                                
                                <div className="step">
                                    <h1>02</h1>
                                    <span className="number">02</span>
                                    <div className="circle"></div>
                                    <h2 style={{ color: '#00675B',fontSize: '20px',fontWeight: 700}}>Submit Task</h2>
                                    <p>Upload your solution with GitHub integration.</p>
                                </div>
                                
                                <div className="step">
                                    <h1>03</h1>
                                    <span className="number">03</span>
                                    <div className="circle"></div>
                                    <h2 style={{ color: '#00675B',fontSize: '20px',fontWeight: 700}}>Get Reviewed</h2>
                                    <p>Receive feedback from mentors and experts.</p>
                                </div>
                                
                                <div className="step">
                                    <h1>04</h1>
                                    <span className="number">04</span>
                                    <div className="circle"></div>
                                    <h2 style={{ color: '#00675B',fontSize: '20px',fontWeight: 700}}>Track Contributions</h2>
                                    <p>See your progress and gain recognition.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="works-section" id="work_sec2">
                    <div className="container steps-section">
                        <h2>How it <span className="highlight">Works</span></h2>
                        <p className="title_1">Solve real-world problems and contribute skills that make a difference</p>

                        <div className="steps-row">
                            <div className="step-box">
                                <div className="step-number">01</div>
                                <div className="step-content">
                                    <p className="step-title">Browse Challenges</p>
                                    <p className="step-description">Explore government-backed software projects.</p>
                                </div>
                            </div>

                            <div className="step-box">
                                <div className="step-number">02</div>
                                <div className="step-content">
                                    <p className="step-title">Submit Task</p>
                                    <p className="step-description">Upload your solution to OpenForge.</p>
                                </div>
                            </div>
                        
                            <div className="step-box">
                                <div className="step-number">03</div>
                                <div className="step-content">
                                    <p className="step-title">Get Reviewed</p>
                                    <p className="step-description">Receive feedback from mentors and experts.</p>
                                </div>
                            </div>

                            
                            <div className="step-box">
                                <div className="step-number" id="step_41">04</div>
                                <div className="step-content">
                                    <p className="step-title">Track Contributions</p>
                                    <p className="step-description">See your progress and gain recognition.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        </>
    )
}